import styled from "styled-components";
import { AttributesView, Inspector } from "@bagel-web/components";
import { FunctionCallResult } from "../../types";

const FunctionCallResultIcon = styled.i`
  font-size: 1.2rem;
  line-height: 1rem;
`;

const FunctionResultTooltip = ({
  resultType,
  fnCallId,
}: {
  resultType: FunctionCallResult;
  fnCallId: string | null;
}) => {
  return (
    <AttributesView
      attributes={[
        {
          name: "function_call_result",
          label: "Function Result",
          value: resultType,
          showMonoValue: false,
        },
        { name: "function_call_id", label: "Request ID", value: fnCallId },
      ]}
    />
  );
};

const DisplayFnResultIcon = ({
  resultType,
  fnCallId,
}: {
  resultType: FunctionCallResult;
  fnCallId: string | null;
}) => {
  let iconClass = null;
  let iconColor = null;
  switch (resultType) {
    case "success":
      iconClass = "bi-check-circle-fill";
      iconColor = "green";
      break;
    case "failure":
      iconClass = "bi-x-circle-fill";
      iconColor = "red";
      break;
    case "warning":
      iconClass = "bi-exclamation-circle-fill";
      iconColor = "orange";
      break;
    case "update":
      iconClass = "bi-clock-fill";
      iconColor = "blue";
      break;
  }

  return (
    <Inspector
      View={FunctionResultTooltip}
      viewProps={{ resultType, fnCallId }}
      showLoading={false}
    >
      <FunctionCallResultIcon
        className={iconClass}
        style={{ color: iconColor }}
      />
    </Inspector>
  );
};

export default DisplayFnResultIcon;
